import Raven from 'raven-js';
import enviro from 'enviro';
const RAVEN_REQUEST_DATA_LENGTH_LIMIT = 1000;
const isDeployed = () => {
  return enviro.deployed('sentry');
};
export function reportMessage(message, extra = {}) {
  console.warn(message, extra);
  if (!isDeployed()) {
    return;
  }
  Raven.captureMessage(message, {
    extra,
    level: 'info'
  });
}
function isHubHttpError(err) {
  return Boolean(typeof err.options === 'object');
}
export const isFailedRequestError = err => typeof err.status === 'number';
export const isJsonErrorResponse = err => isFailedRequestError(err) && Boolean(err.responseJSON) && typeof err.responseJSON === 'object';
export function reportError(err, extra = {}) {
  console.error(err);
  if (!isDeployed()) {
    return;
  }
  const actionName = extra.action || extra.type || 'UNKNOWN';
  let tags = {
    actionName
  };
  if (isFailedRequestError(err)) {
    const level = 'warning';
    tags.status = err.status;
    if (err instanceof XMLHttpRequest) {
      const errorMessage = `Failed quickFetch request for ${actionName} with status: ${err.status}`;
      Raven.captureMessage(errorMessage, {
        level,
        tags,
        extra
      });
    } else if (isHubHttpError(err)) {
      if (typeof err.options === 'object') {
        tags = Object.assign({}, tags, {
          requestUrl: err.options.url,
          requestMethod: err.options.method
        });
        if (err.options.data && typeof err.options.data === 'string') {
          extra.requestBody = err.options.data.substr(0, RAVEN_REQUEST_DATA_LENGTH_LIMIT);
        }
      }
      if (typeof err.responseText === 'string') {
        extra.responseBody = err.responseText.substr(0, RAVEN_REQUEST_DATA_LENGTH_LIMIT);
      }
      const errorMessage = `Failed hub-http request for ${actionName} with status: ${err.status}`;
      Raven.captureMessage(errorMessage, {
        level,
        tags,
        extra
      });
    }
    return;
  }
  Raven.captureException(err, {
    extra,
    tags
  });
}
export function mockCurrentApp(currentApp) {
  window._currentApp = currentApp;
}
export function getCurrentApp() {
  if (window._currentApp) {
    return window._currentApp;
  }
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    window.hubspot &&
    // @ts-ignore No hubspot type in global window yet
    window.hubspot.bender &&
    // @ts-ignore No hubspot type in global window yet
    window.hubspot.bender.currentProject
  );
}
export function getCurrentAppVersion() {
  if (window._currentApp) {
    return null;
  }
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    window.hubspot &&
    // @ts-ignore No hubspot type in global window yet
    window.hubspot.bender &&
    // @ts-ignore No hubspot type in global window yet
    window.hubspot.bender.currentProjectVersion
  );
}
export function serializeFileInfo(file) {
  return {
    fileName: file.name,
    fileType: file.type,
    fileSize: file.size
  };
}
export const logBadConversionAssetData = (failureMessage, error = '') => {
  console.warn(`[Video HubL Tag] ${failureMessage}. HubL tag will ignore it. ${error}`);
};